import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavContainerComponent } from './nav-container/nav-container.component';

@NgModule({
  declarations: [
    NavContainerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NavContainerComponent
  ]
})
export class LayoutUtilsModule { } 